import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  Label,
} from "reactstrap";
import Utils from "../Utility";
import { post, get, put, upload } from "../../helpers/api_helper";
import DeleteModal from "./DeleteModal";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import UserProfile from "../../components/UserProfile";
import { AvField, AvForm } from "availity-reactstrap-validation";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import Loader from "../../components/Loader";
import Resizer from "react-image-file-resizer";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";

const Table = (props) => {
  const { user } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      getData();
      getTables();
    }
  }, [user]);

  const getData = () => {
    setLoading(true); // Set loading state to true when making the API request
    get("/contact", { token: user?.token })
      .then((json) => {
        console.log("response from get project list", json);
        if (json?.statusCode == 200) {
          setData(json?.data);
        }
        setLoading(false); // Set loading state to false after receiving the response
      })
      .catch((error) => {
        console.log("error while getting project list", error);
      });
  };

  const getTables = () => {
    get("/contact/table/list", { token: user?.token })
      .then(res => {
        if (res?.statusCode == 200) {
          setTables(res?.data);
        }
      })
  }

  // console.log("get inquiry data =============>", data);

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => (
          <>
            <Draggable key={row._id} draggableId={row._id} index={index}>
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <i
                    className="mdi mdi-menu"
                    style={{ fontSize: 20, color: Utils.themeColor }}
                  ></i>
                </div>
              )}
            </Draggable>
          </>
        ),
        maxWidth: "50px",
      },
      {
        name: "Name",
        selector: (row) => row?.name,
        maxWidth: "380px",
      },
      {
        name: "Designation",
        selector: (row) => row?.designation,
        maxWidth: "380px",
      },
      {
        name: "Mobile",
        selector: (row) => row?.mobile,
        maxWidth: "130px",
      },
      {
        name: "Fax",
        selector: (row) => row?.fax,
        maxWidth: "130px",
      },
      {
        name: "Remark",
        selector: (row) => row?.remark,
        maxWidth: "450px",
      },
      {
        name: "Table Name",
        selector: (row) => row?.table?.length ? row?.table[0]?.title : "-",
        cell: (row)=>(
          <span title={row?.table?.length ? row?.table[0]?.title : "-"}>{row?.table?.length ? row?.table[0]?.title : "-"}</span>
        ),
        maxWidth: "450px",
        sortable: true
      },
      {
        cell: (row) => (
          <div className="table_btn">
            <button
              onClick={() => handleUpdateStatus(row)}
              className={row?.isActive ? "active_status" : "inactive_status"}
            >
              <span className="text-white" style={{}}>
                {row?.isActive ? "Active" : "Inactive"}
              </span>
            </button>
          </div>
        ),
        name: "Status",
        ignoreRowClick: true,
        maxWidth: "120px",
        sortable: true,
      },
      {
        cell: (row) => (
          <>
            <div className="action_btn table_btn">
              <button
                onClick={() => handleUpdateProj(row)}
              >
                <i class="mdi mdi-pencil"></i>
              </button>
              <button
                onClick={() => handleDeleteProj(row)}
              >
                <i class="mdi mdi-delete"></i>
              </button>
            </div>
          </>
        ),
        name: "Action",
        ignoreRowClick: true,
        maxWidth: "120px",
      },
    ]);
  }, [data]);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
    }
  }, [isAddForm]);

  const handleUpdateProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData(proj);
    setIsAddForm(true);
  };

  const handleUpdateStatus = (item) => {
    setCurrentData({ ...item, actionType: "Status" });
    setDeleteModal(true);
  };

  const handleDeleteProj = (proj) => {
    // console.log('updating proj', proj);
    setCurrentData({ ...proj, actionType: "Delete" });
    setDeleteModal(true);
  };

  const onDelete = () => {
    let body = {
      memberId: currentData?._id,
      token: user?.token
    };
    if (currentData?.actionType == "Status")
      body = { ...body, isActive: !currentData?.isActive }
    else
      body = { ...body, isDeleted: true }
    put("/contact", body)
      .then((res) => {
        setLoading(false);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          setDeleteModal(false);
          getData();
          props?.setCurrentData(null);
        } else {
          toast.error(res?.error);
        }
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  };

  const handleDragEnd = (result) => {
    console.log("dragging item", result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [],
      position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    });
    let body = {
      ids,
      position,
      token: user?.token,
    };
    put("/contact/position", body).then((res) => {
      // if (res?.statusCode == 200)
      setData(items);
    });
  };

  const handleValidSubmit = async (e, v) => {
    console.log("values", v);
    let body = {
      ...v,
      token: user?.token,
    };
    setLoading(true);
    if (currentData) {
      body = { ...body, memberId: currentData?._id };
      put("/contact", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/contact", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            getData();
            setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <DeleteModal
            show={deleteModal}
            onDeleteClick={() => onDelete()}
            onCloseClick={() => setDeleteModal(false)}
            data={currentData}
          />
          <Modal isOpen={isAddForm} centered={true} style={{ maxWidth: 800 }}>
            <ModalBody className="py-3 px-5">
              <h5 className="text-black font-size-20">
                {currentData ? `Update Member` : `Add New Member`}
              </h5>
              <div className="p-2">
                <AvForm
                  className="form-horizontal"
                  onValidSubmit={handleValidSubmit}
                >
                  <Row>
                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        <AvField
                          name="tableId"
                          label="Table Name *"
                          className="form-control"
                          type="select"
                          required
                          value={currentData?.tableId}
                        >
                          <option value="">Select Table</option>
                          {tables?.map((item) => (
                            <option value={item?._id}>{item?.title}</option>
                          ))}
                          {/* <option value="bod">BOARD OF DIRECTORS, IDPL</option>
                          <option value="bodChennai">BOARD OF DIRECTORS, 100% Subsidiary IDPL(TN), Chennai</option>
                          <option value="bodMuzaffarpur">BOARD OF DIRECTORS, 100% Subsidiary Bihar Drugs & Organic Chemicals Ltd. (BDOCL), Muzaffarpur</option>
                          <option value="bodBhubaneswar">BOARD OF DIRECTORS, Joint Venture Orissa Drugs & Chemicals Ltd. (ODCL). Bhubaneswar</option>
                          <option value="seniorOfficial">SENIOR OFFICIALS</option> */}
                        </AvField>
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="mb-3">
                        <AvField
                          name="name"
                          label="Member Name *"
                          className="form-control"
                          placeholder="Enter member name"
                          type="text"
                          required
                          value={currentData?.name}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="mb-3">
                        <AvField
                          name="designation"
                          label="Member designation *"
                          className="form-control"
                          placeholder="Enter member designation"
                          type="text"
                          required
                          value={currentData?.designation}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="mb-3">
                        <AvField
                          name="mobile"
                          label="Member mobile *"
                          className="form-control"
                          placeholder="Enter member mobile"
                          type="text"
                          required
                          value={currentData?.mobile}
                        />
                      </div>
                    </Col>
                    <Col lg={6} md={6}>
                      <div className="mb-3">
                        <AvField
                          name="fax"
                          label="Member fax *"
                          className="form-control"
                          placeholder="Enter member fax"
                          type="text"
                          required
                          value={currentData?.fax}
                        />
                      </div>
                    </Col>
                    <Col lg={12} md={12}>
                      <div className="mb-3">
                        <AvField
                          name="remark"
                          label="Member remark *"
                          className="form-control"
                          placeholder="Enter member remark"
                          type="text"
                          required
                          value={currentData?.remark}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="mt-4">
                    <Row>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                          onClick={() => {
                            setIsAddForm(false);
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          style={{
                            backgroundColor: Utils.themeColor,
                            border: "none",
                          }}
                        >
                          {currentData ? "Update" : "Add"}
                        </button>
                      </Col>
                    </Row>
                  </div>
                </AvForm>
              </div>
            </ModalBody>
          </Modal>

          <Col className="col-12">
            <div className="table_top_header">
              <Row style={{ width: '100%' }}>
                <Col md={11}>
                  Contact - US
                </Col>
                <Col md={1}>
                  <div className="add_btn" onClick={() => setIsAddForm(true)}>
                    <i className="mdi mdi-plus" />
                  </div>
                </Col>
              </Row>
            </div>
            <Card style={{ borderRadius: "0" }} className="table-body-section">
              <CardBody>
                <div className="table-search-section">
                  {/* <div className="search_field">
                    <label>Search :</label>
                    <input
                      type="text"
                      value={""}
                      onChange={(e) => handleFilter(e.target.value)}
                    />
                  </div> */}
                </div>
                <Loader visible={loading} />
                {loading && <div>Loading...</div>}
                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="table">
                    {(provided) => (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        <DataTable
                          columns={columns}
                          data={data}
                          pagination
                          // expandableRows
                          // expandableRowsComponent={ExpandedComponent}
                          // onRowClicked={(row) => handleExpandRow(row)}
                          // expandOnRowClicked
                          // isRowExpandable={(row) => true}
                          // isRowExpanded={isRowExpanded}
                          paginationPerPage={100}
                          paginationRowsPerPageOptions={[100, 200, 300, 400]}
                          conditionalRowStyles={[
                            {
                              when: (row) => row?.style,
                              style: (row) => ({ width: row?.style?.width }),
                            },
                          ]}
                          customStyles={{
                            headCells: {
                              style: {
                                color: "black",
                                fontWeight: "bold",
                                fontSize: 15,
                                width: 0,
                              },
                            },
                            cells: {
                              style: {
                                width: 0,
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Table;
